import Loader from './Loader';

export default {
  mixins: [Loader],
  computed: {
    /**
     * @returns {HTMLElement}
     */
    paymentForm() {
      return document.getElementById('payment-form');
    },
    /**
     * @returns {HTMLElement}
     */
    paymentButton() {
      return document.getElementById('payment-button');
    },
    /**
     * @returns {HTMLElement}
     */
    termsAndConditionsInput() {
      return document.getElementById('terms-conditions-1');
    },
  },
  methods: {
    /**
     * @returns {boolean}
     */
    reportFormValidity() {
      return this.paymentForm.reportValidity();
    },
    hasVisibleCustomButtons() {
      return Array.from(
        document.getElementsByClassName('form-actions__btn')
      ).some(button => button.checkVisibility());
    },
  },
};
